module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    class: _vm.color
  }, [_c('header-app'), _vm._v(" "), _c('menunav-app', {
    attrs: {
      "linksPath": _vm.linksPath
    }
  }), _vm._v(" "), _c('accesmen-app'), _vm._v(" "), _c('main', {
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('v-layout', {
    staticClass: "appcontain",
    attrs: {
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)]), _vm._v(" "), _c('footer-app'), _vm._v(" "), _c('button', {
    staticClass: "offscreen",
    on: {
      "click": _vm.ir_a_region_principal
    }
  }, [_vm._v("Volver a la región principal")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-337664c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 957
// module chunks = 1